
async function resendActivationEmail() {
    try {
       var email = document.getElementById('activation-email').value;
       var shopName=document.getElementById('shop-name').getAttribute('data-product-id');
       document.getElementById('email-error-message').style.display = "none";
       document.getElementById('customer-error-message').style.display="none";
       document.getElementById('success-message').style.display = "none";
       document.getElementById('error-message').style.display = "none";
        if (email === '') {
          document.getElementById('email-error-message').style.display = "block";
          return;
        }
      const res = await fetch(
        "https://send-invitation-2-df8b361bf586.herokuapp.com/activateEmail",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: email, shop: shopName }),
        }
      );
      const data = await res.json();
      if(data?.customer_invite){
        document.getElementById('activation-email').value="";
        document.getElementById('success-message').style.display = "block";      
      }
      else if(data.msg === "Customer not found"){
        document.getElementById('customer-error-message').style.display="block";
      }
      else{
        document.getElementById('error-message').style.display = "block";
      }
    } catch (error) {
      console.log(error);
    }
  }


